import * as checked from 'reporting-data/lib/checked';
import { Dataset } from 'reporting-data/v2/dataset/datasetRecords';
import { CROSS_TAB } from '../../constants/visualizationTypes';
import { Order } from '../../field/order';
export const Alignments = {
  left: 'left',
  right: 'right'
};
export const Align = checked.symbol(Alignments, 'Align');
export const EncodingTypes = {
  row: 'row',
  column: 'column'
};
export const EncodingType = checked.symbol(EncodingTypes, 'EncodingTypes');
export const EncodingLabel = checked.record({
  label: checked.string(),
  headerData: checked.map(),
  encodingSize: checked.number().defaultValue(1),
  onSort: checked.func().optional(),
  align: Align.optional(),
  encodingType: EncodingType.optional()
}, 'EncodingLabel');
export const Events = checked.record({
  onClick: checked.func().optional(),
  getColumnOnClick: checked.func().optional()
}, 'Events');
export const Encoding = checked.record({
  field: checked.string(),
  onSort: checked.func().optional(),
  order: Order.optional(),
  nested: checked.boolean().optional(),
  formattingType: checked.string().optional(),
  formattingObject: checked.any().optional()
}, 'Encoding');
export const CrossTabVisualization = checked.record({
  type: checked.string().always(CROSS_TAB),
  data: checked.map(Dataset),
  dataset: checked.string().optional().defaultValue('primary'),
  columns: checked.list(Encoding).optional().defaultValue([]),
  rows: checked.list(Encoding).optional().defaultValue([]),
  rowTotal: checked.list(checked.string()).defaultValue([]),
  columnTotal: checked.list(checked.string()).defaultValue([]),
  showColumnSubtotals: checked.boolean().defaultValue(false),
  showRowSubtotals: checked.boolean().defaultValue(false),
  showColumnTotal: checked.boolean().optional(),
  showRowTotal: checked.boolean().optional(),
  grandTotal: checked.list(checked.string()).defaultValue([]),
  events: Events.optional(),
  values: checked.list(Encoding).optional().defaultValue([])
}, 'CrossTabVisualization');